<div class="event-carousel-skeleton__timer-info-wrapper">
    <ms-skeleton variant="text" width="75px" />
</div>
<ng-container *ngTemplateOutlet="teamTemplate; context: { textWidth: '39px' }" />
<ng-container *ngTemplateOutlet="teamTemplate; context: { textWidth: '49px' }" />

<ng-template #teamTemplate let-textWidth="textWidth">
    <div class="event-carousel-skeleton__team-info">
        <div class="event-carousel-skeleton__left-container">
            <ms-skeleton variant="circular" width="16px" height="16px" />
            <ms-skeleton variant="text" [width]="textWidth" />
        </div>
        <ms-skeleton variant="text" width="22px" />
    </div>
</ng-template>
